import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  addCrashBreadcrumb,
  markReactMounted,
} from "../../services/clientCrashReporter";
import {
  normalizeRoutablePathname,
  redactSensitiveRoutePathname,
} from "../../services/routePath";

function CrashBootMarker() {
  useLayoutEffect(() => {
    markReactMounted();
    addCrashBreadcrumb({
      category: "app",
      message: "react_mounted",
    });
  }, []);

  return null;
}

function CrashRouteObserver() {
  const location = useLocation();

  useEffect(() => {
    addCrashBreadcrumb({
      category: "route",
      message: "route_change",
      data: {
        pathname: redactSensitiveRoutePathname(
          normalizeRoutablePathname(location.pathname),
        ),
      },
    });
  }, [location.pathname]);

  return null;
}

export { CrashBootMarker, CrashRouteObserver };
